import { create } from 'zustand';

/**
 * Global loader overlay store — replaces Angular `LoaderService.isLoading$`
 * (raptor-shell-ui/src/app/core/services/loader.service.ts).
 *
 * Legacy contract is intentionally preserved byte-exact for parity:
 *   - `display(message?)` shows the overlay; subsequent calls just update the
 *     message (no ref-counting — the legacy Subject simply emitted `true`).
 *   - `hide()` hides unconditionally, regardless of how many display calls
 *     fired beforehand.
 *
 * Window globals `EY_RAPToR_displayLoader` / `EY_RAPToR_hideLoader` are NOT
 * installed here — they're bound in the SDK shim during M2.9 so the entire
 * legacy-globals surface is wired in one place with parity tests.
 */
interface LoaderState {
  show: boolean;
  message: string;
  display: (message?: string) => void;
  hide: () => void;
}

export const useLoaderStore = create<LoaderState>((set) => ({
  show: false,
  message: '',
  display: (message = '') => set({ show: true, message }),
  hide: () => set({ show: false, message: '' }),
}));

/** Imperative helpers — usable outside React (HTTP interceptor, MFE loader, etc.). */
export const displayLoader = (message?: string): void => {
  useLoaderStore.getState().display(message);
};

export const hideLoader = (): void => {
  useLoaderStore.getState().hide();
};
